import { Tipologia } from 'app/modules/models/tipologia.model';

export class UsuarioModel {
    usuarioId: number;
    nombreCompleto: string = '';
    email: string = '';
    password:string = '';
    rol: Tipologia | null = null;
    dependencia:Tipologia;
    estado?: Tipologia
}
